import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Command", -1)
const _hoisted_3 = { class: "settings-row" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Run as console", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.action.command = $event))
      }, null, 512), [
        [_vModelText, _ctx.action.command]
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.asConsole = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.action.asConsole]
      ])
    ])
  ]))
}